export enum WalletRoutesEnum {
  signAndSend = '/sign-and-send',
  registrationForApps = '/registration-for-apps',
  send = '/send',
  myAssets = '/my-assets',
  assetSelection = '/selection',
  transactions = '/transactions',
  add = '/add',
  buy = '/buy',
  signup = '/signup',
  root = '/',
  login = '/login',
  iframe = '/iframe',
  sso = '/sso',
}

export enum HubRoutesEnum {
  myAssets = '/my-assets',
  discover = '/discover',
  myPlace = '/my-place',
  build = '/build',
  contribute = '/contribute',
  sso = '/sso',
  root = '/',
}
